const STORAGE_KEY = 'reformfc-accent-theme';
const root = document.documentElement;
const accentLocked = root.getAttribute('data-accent-locked') === 'true';

function getStoredAccentTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'pink' ? 'pink' : 'blue';
  } catch (error) {
    return 'blue';
  }
}

function storeAccentTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch (error) {
    // localStorage can be unavailable in strict privacy modes.
  }
}

function syncToggleButtons(theme) {
  const isPink = theme === 'pink';

  document.querySelectorAll('[data-accent-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', String(isPink));
    button.setAttribute('aria-label', isPink ? 'Use blue accents' : 'Use pink accents');
    button.querySelectorAll('[data-accent-toggle-tooltip]').forEach((tooltip) => {
      tooltip.textContent = isPink ? 'Back to blue' : 'See it in pink';
    });
  });
}

function applyAccentTheme(theme, shouldStore = false) {
  if (accentLocked) {
    theme = root.getAttribute('data-accent-theme') === 'pink' ? 'pink' : 'blue';
    shouldStore = false;
  }

  root.setAttribute('data-accent-theme', theme);
  syncToggleButtons(theme);

  if (shouldStore) {
    storeAccentTheme(theme);
  }
}

applyAccentTheme(root.getAttribute('data-accent-theme') || getStoredAccentTheme());

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const toggle = target ? target.closest('[data-accent-toggle]') : null;

  if (!toggle || accentLocked) {
    return;
  }

  const nextTheme = root.getAttribute('data-accent-theme') === 'pink' ? 'blue' : 'pink';
  applyAccentTheme(nextTheme, true);
});

document.addEventListener('shopify:section:load', () => {
  applyAccentTheme(root.getAttribute('data-accent-theme') || getStoredAccentTheme());
});
